<template>
  <div class="container">
    <img class="bg" src="static/loginbackground.jpg"/>
    <div class="content">
      <div class="top">
        <div class="header">
          <img  alt="logo" style="height:4em" class="logo" src="static/trees.png" />
          <p class="title" style="font-size:2em">数据管理系统</p>
        </div>
        <div class="desc"></div>
      </div>
      <component :is="componentName" @regist="handleRegist" class="main-content"></component>
    </div>
  </div>
</template>

<script>
import Login from './Login'
import Regist from './Regist'

export default {
  name: 'Common',
  components: { Login, Regist},
  data () {
    return {
      componentName: 'Login'
    }
  },
  computed: {
    // systemName () {
    //   return this.$store.state.setting.systemName
    // },
    // copyright () {
    //   return this.$store.state.setting.copyright
    // }
  },
  methods: {
    handleRegist (val) {
      this.componentName = val
    }
  }
}
</script>

<style scoped>
.bg {
  display:block;
  filter: blur(8px);
  position: fixed;
  top: 0;
  left:0;
  height: 100vh;
  width: 100vw;
  /* background-image: url("/loginbackground.jpg"); */
}
.logo{border-radius: 10%;}
.content {
  background-color: rgba(0, 0, 0, 0.2); /* Black w/opacity/see-through */
  color: white;
  /* font-weight: bold; */
  box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.2), 0 5px 5px 0 rgba(0, 0, 0, 0.24);
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 2;
  width: 80%;
  padding: 20px;
  text-align: center;
}

</style>


// WEBPACK FOOTER //
// src/components/login/common.vue